// @ts-nocheck



import React, { Component } from 'react';
import { Link } from '../../lib/routerAdapter';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';
import qs from 'query-string';

import notification from 'antd/lib/notification';
import Button from 'antd/lib/button';


import { vehicleIssueGroupApi } from './../../lib/api';

import { accessTypeEnum } from './../../lib/enum';
import { getListInitialState, setQueryParams } from './../../lib/helpers';

import { notificationLoading } from './../../components/Notifications';
import { Header, Section } from './../../components/layout';
import { Popconfirm, Icon, Operations, Table } from './../../components/ui';


import { withUserAccess } from './../withUserAccess';

import Filter from './components/Filter';

const StyledIcon = styled(Icon).withConfig({ displayName: "VehicleIssueGroupList__StyledIcon", componentId: "sc-1kbwq44-0" })(["margin:0 5px;color:#1890ff;cursor:pointer;"]);




const addAccess = [
accessTypeEnum.admin,
accessTypeEnum.adminBranch,
accessTypeEnum.handlingVehicleIssueGroups];











export class VehicleIssueGroupList extends Component {
  state = {
    ...getListInitialState(),
    filter: {}
  };

  columns = [
  {
    title: '№',
    dataIndex: 'id',
    sorter: true,
    width: 50
  },
  {
    title: 'Наименование',
    dataIndex: 'name',
    sorter: true
  }];


  deleteVehicleIssueGroup = async (id) => {
    try {
      notificationLoading({
        message: 'Удаление...',
        key: 'deleting'
      });
      await vehicleIssueGroupApi.deleteVehicleIssueGroup(id);
      await this.fetchVehicleIssueGroup(this.state.page);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('deleting');
    }
  };

  fetchVehicleIssueGroup = async (
  page = 1,
  params = {}) =>
  {
    this.setState({ loading: true });
    const { data, totalCount } =
    await vehicleIssueGroupApi.fetchVehicleIssueGroup({
      page,
      ...params,
      ...this.state.filter
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  canAdd = () =>
  this.props.userAccess.some((access) => addAccess.includes(access));

  async componentDidMount() {
    const { page } = qs.parse(window.location.search);
    if (this.canAdd()) {
      this.columns.push({
        title: '',
        width: '30px',
        stopPropagation: true,
        render: (record) =>
        <Operations>
            <Popconfirm
            title="Вы действительно хотите удалить?"
            okText="Да"
            cancelText="Нет"
            onConfirm={async () =>
            await this.deleteVehicleIssueGroup(record.id)
            }>

              <StyledIcon type="x" />
            </Popconfirm>
          </Operations>

      });
    }
    await this.fetchVehicleIssueGroup(page);
  }

  applyFilter = (filter) => {
    const { page } = this.state;
    this.setState({ filter, loading: true }, () =>
    this.fetchVehicleIssueGroup(page)
    );
  };

  cleanFilter = () => {
    const { page } = this.state;
    this.setState({ filter: {}, loading: true }, () =>
    this.fetchVehicleIssueGroup(page)
    );
  };

  render() {
    const { location } = this.props;
    const { data, totalCount, pageSize, page, loading, filter } = this.state;
    const canAdd = this.canAdd();
    return (
      <>
        <Header
          left={<h1>Группы дефектов</h1>}
          right={
          canAdd &&
          <Link to="/admin/vehicle-issue-group/new">
                <Button type="primary">Создать</Button>
              </Link>

          } />

        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () =>
              navigate(`/admin/vehicle-issue-group/edit/${record.id}`)
            })}
            columns={this.columns}
            fetch={this.fetchVehicleIssueGroup}
            loading={loading}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }}
            data={data} />

        </Section>
      </>);

  }
}

export default withUserAccess(VehicleIssueGroupList);
